import React, { useEffect } from 'react';
import { Route, Router, Routes, useLocation } from "react-router-dom";
// import {ScrollRestoration} from "react-router-dom-dom";
import Nav from "./components/Nav/Nav";
import LandingPage from "./components/Website/LandingPage";
import styled from '@emotion/styled';
import About from "./components/Website/About";
import Map from "./components/Map/Map";
import ScrollToTop from "./components/Shared/ScrollToTop";

function App() { 

  const { pathname, hash, key } = useLocation();

  useEffect(() => {
    // if not a hash link, scroll to top
    if (hash === '') {
      window.scrollTo(0, 0);
    }
    // else scroll to id
    else {
      setTimeout(() => {
        const id = hash.replace('#', '');
        const element = document.getElementById(id);
        if (element) {
          element.scrollIntoView({
            behavior: "smooth",
            // block: "end",
            inline: "nearest",
          });
        }
      }, 200); // delay to have scroll effect
    }
  }, [pathname, hash, key]); // do this on route change

  return (
    <AppContainer>
      <StickHeaderStyle>
        <Nav />
      </StickHeaderStyle>
      <Content>
        <ScrollToTop />
          <Routes>
            <Route path="/" element={<LandingPage />} />
            <Route path="/map" element={<Map />} />
            <Route path="/about" element={<About />} />
          </Routes>
        <ScrollToTop />
      </Content>
    </AppContainer>
  );
}

export default App;

const AppContainer = styled.div<{}>(() => `
  display: flex;
  flex-direction: column;
  //height: 100vh;
`);

const StickHeaderStyle = styled.div<{}>(() => `
  z-index: 100;
  position: fixed;
  width: 100%;
  top: 0;
`);

const Content = styled.div<{}>(() => `
  flex: 1;
  // overflow-y: auto;
`);